import _assign from "object-assign";
var FILL_PATTERN_WIDTH = 10,
    FILL_PATTERN_HEIGHT = 10;
var dot = // dot
1,
    shortDash = // dash
3,
    longDash = // long dash
8,
    shortGap = // narrow gap
1,
    longGap = // wide gap
3;

var addGap = function addGap(markerArray, gapLength) {
  return markerArray.reduce(function (dashStyle, marker, index) {
    return "".concat(dashStyle).concat(index === 0 ? '' : ',').concat(marker, ",").concat(gapLength);
  }, '');
};

var fillPatternProps = [{
  id: 'diagonal-up',
  children: [{
    tagName: 'path',
    d: 'M0,7.00198364 L0,5 L5,0 L7,0 L0,7.00198364 Z M7,10 L5,10 L10,5 L10,6.99545288 L7,10 Z'
  }]
}, {
  id: 'dot',
  children: [{
    tagName: 'path',
    d: 'M1.5,3 C0.671572875,3 0,2.32842712 0,1.5 C0,0.671572875 0.671572875,0 1.5,0 C2.32842712,0 3,0.671572875 3,1.5 C3,2.32842712 2.32842712,3 1.5,3 Z M6.5,8 C5.67157288,8 5,7.32842712 5,6.5 C5,5.67157288 5.67157288,5 6.5,5 C7.32842712,5 8,5.67157288 8,6.5 C8,7.32842712 7.32842712,8 6.5,8 Z'
  }]
}, {
  id: 'zigzag',
  children: [{
    tagName: 'path',
    d: 'M0.348320584,7.36616848 C0.153296904,7.56166881 -0.163285349,7.5620552 -0.358785671,7.36703152 C-0.554285993,7.17200784 -0.554672388,6.85542559 -0.359648709,6.65992527 L4.64298801,1.64506199 C4.83835298,1.44921954 5.15561055,1.4492248 5.35096902,1.64507373 L10.3532737,6.65993701 C10.5482909,6.85544381 10.547894,7.17202605 10.3523872,7.36704324 C10.1568804,7.56206043 9.84029817,7.56166353 9.64528098,7.36615674 L4.99696091,2.70616677 L0.348320584,7.36616848 Z'
  }]
}, {
  id: 'vertical-lines',
  children: [{
    tagName: 'path',
    d: 'M0,2.5 C0,2.22385763 0.223857625,2 0.5,2 C0.776142375,2 1,2.22385763 1,2.5 L1,7.47487373 C1,7.75101611 0.776142375,7.97487373 0.5,7.97487373 C0.223857625,7.97487373 0,7.75101611 0,7.47487373 L0,2.5 Z'
  }, {
    tagName: 'path',
    d: 'M5,7.5 C5,7.22385763 5.22385763,7 5.5,7 C5.77614237,7 6,7.22385763 6,7.5 L6,10 C6,10.2761424 5.77614237,10.5 5.5,10.5 C5.22385763,10.5 5,10.2761424 5,10 L5,7.5 Z'
  }, {
    tagName: 'path',
    d: 'M5,0 C5,-0.276142375 5.22385763,-0.5 5.5,-0.5 C5.77614237,-0.5 6,-0.276142375 6,0 L6,2.47487373 C6,2.75101611 5.77614237,2.97487373 5.5,2.97487373 C5.22385763,2.97487373 5,2.75101611 5,2.47487373 L5,0 Z'
  }]
}, {
  id: 'diagonal-down',
  children: [{
    tagName: 'path',
    d: 'M0,7.00198364 L0,5 L5,0 L7,0 L0,7.00198364 Z M7,10 L5,10 L10,5 L10,6.99545288 L7,10 Z',
    transform: 'translate(5.000000, 5.000000) rotate(90.000000) translate(-5.000000, -5.000000) '
  }]
}, {
  id: 'upward-point',
  children: [{
    tagName: 'polygon',
    points: '0.581221305 4.4843665 0 4.04232568 2.38452148 0 4.76904297 4.04232568 4.18782166 4.4843665 2.38452148 1.42734786'
  }, {
    tagName: 'polygon',
    points: '5.5812213 9.4843665 5 9.04232568 7.38452148 5 9.76904297 9.04232568 9.18782166 9.4843665 7.38452148 6.42734786'
  }]
}, {
  id: 'horizontal-lines',
  children: [{
    tagName: 'path',
    d: 'M2.5,2 C2.22385763,2 2,1.77614237 2,1.5 C2,1.22385763 2.22385763,1 2.5,1 L7.5,1 C7.77614237,1 8,1.22385763 8,1.5 C8,1.77614237 7.77614237,2 7.5,2 L2.5,2 Z'
  }, {
    tagName: 'path',
    d: 'M7.5,7 C7.22385763,7 7,6.77614237 7,6.5 C7,6.22385763 7.22385763,6 7.5,6 L10,6 C10.2761424,6 10.5,6.22385763 10.5,6.5 C10.5,6.77614237 10.2761424,7 10,7 L7.5,7 Z'
  }, {
    tagName: 'path',
    d: 'M0,7 C-0.276142375,7 -0.5,6.77614237 -0.5,6.5 C-0.5,6.22385763 -0.276142375,6 0,6 L2.5,6 C2.77614237,6 3,6.22385763 3,6.5 C3,6.77614237 2.77614237,7 2.5,7 L0,7 Z'
  }]
}, {
  id: 'crosshatch',
  children: [{
    tagName: 'path',
    d: 'M5,6 L0,1 L0.0276958658,0.972304134 L0.0276958658,2.22044605e-16 L0.513847933,3.33066907e-16 L1,3.33066907e-16 L6,5 L5.97230413,5.02769587 L5.97230413,6 L5.48615207,6 L5,6 Z M10,7 L7,10 L5,10 L6,9 L9,6 L10,5 L10,7 Z M0,5 L1,6 L0,7 L0,5 Z M7,0 L6,1 L5,0 L7,0 Z'
  }]
}, {
  id: 'net',
  children: [{
    tagName: 'path',
    d: 'M4,0.5 C4,0.223857625 4.22385763,-1.8189894e-12 4.5,-1.8189894e-12 C4.77614237,-1.8189894e-12 5,0.223857625 5,0.5 L5,2.5 C5,2.77614237 4.77614237,3 4.5,3 C4.22385763,3 4,2.77614237 4,2.5 L4,0.5 Z'
  }, {
    tagName: 'path',
    d: 'M4,6.5 C4,6.22385763 4.22385763,6 4.5,6 C4.77614237,6 5,6.22385763 5,6.5 L5,8.5 C5,8.77614237 4.77614237,9 4.5,9 C4.22385763,9 4,8.77614237 4,8.5 L4,6.5 Z'
  }, {
    tagName: 'path',
    d: 'M2.5,4 C2.77614237,4 3,4.22385763 3,4.5 C3,4.77614237 2.77614237,5 2.5,5 L0.5,5 C0.223857625,5 -2.27373675e-13,4.77614237 -2.27373675e-13,4.5 C-2.27373675e-13,4.22385763 0.223857625,4 0.5,4 L2.5,4 Z'
  }, {
    tagName: 'path',
    d: 'M8.5,4 C8.77614237,4 9,4.22385763 9,4.5 C9,4.77614237 8.77614237,5 8.5,5 L6.5,5 C6.22385763,5 6,4.77614237 6,4.5 C6,4.22385763 6.22385763,4 6.5,4 L8.5,4 Z'
  }]
}, {
  id: 'steps',
  children: [{
    tagName: 'polygon',
    points: '9 9.09494702e-13 10 9.09494702e-13 10 2 9 2'
  }, {
    tagName: 'polygon',
    points: '10 6 10 12 9 12 9 7 4 7 4 2 1.13686838e-13 2 1.13686838e-13 1 5 1 5 6.5 4.5 6'
  }]
}, {
  id: 'pavement',
  children: [{
    tagName: 'polygon',
    points: '2 8.70710678 5.53553391 12.2426407 6.24264069 11.5355339 2.70710678 8'
  }, {
    tagName: 'polygon',
    points: '3 -0.292893219 6.53553391 3.24264069 7.24264069 2.53553391 3.70710678 -1'
  }, {
    tagName: 'polygon',
    points: '10.3535534 0.353553391 0.353553391 10.3535534 -0.353553391 9.64644661 9.64644661 -0.353553391'
  }, {
    tagName: 'polygon',
    points: '10 9.3 10 10 9.3 10'
  }, {
    tagName: 'polygon',
    points: '-5.77315973e-15 0.7 -5.77315973e-15 2.2759572e-14 0.7 2.2759572e-14'
  }]
}, {
  id: 'scallop',
  children: [{
    tagName: 'path',
    d: 'M2.58192362,1.20002943 C2.74760904,0.979115526 3.06100972,0.934344001 3.28192362,1.10002943 C3.50283752,1.26571485 3.54760904,1.57911553 3.38192362,1.80002943 C2.29673986,3.2469411 1.16710738,4.00002943 -0.0180763806,4.00002943 C-1.20326014,4.00002943 -2.33289262,3.2469411 -3.41807638,1.80002943 C-3.58376181,1.57911553 -3.53899028,1.26571485 -3.31807638,1.10002943 C-3.09716248,0.934344001 -2.78376181,0.979115526 -2.61807638,1.20002943 C-1.70326014,2.41978441 -0.832892622,3.00002943 -0.0180763806,3.00002943 C0.796739861,3.00002943 1.66710738,2.41978441 2.58192362,1.20002943 Z'
  }, {
    tagName: 'path',
    d: 'M12.6,1.20002943 C12.7656854,0.979115526 13.0790861,0.934344001 13.3,1.10002943 C13.5209139,1.26571485 13.5656854,1.57911553 13.4,1.80002943 C12.3148162,3.2469411 11.1851838,4.00002943 10,4.00002943 C8.81481624,4.00002943 7.68518376,3.2469411 6.6,1.80002943 C6.43431458,1.57911553 6.4790861,1.26571485 6.7,1.10002943 C6.9209139,0.934344001 7.23431458,0.979115526 7.4,1.20002943 C8.31481624,2.41978441 9.18518376,3.00002943 10,3.00002943 C10.8148162,3.00002943 11.6851838,2.41978441 12.6,1.20002943 Z'
  }, {
    tagName: 'path',
    d: 'M7.6,6.20002943 C7.76568542,5.97911553 8.0790861,5.934344 8.3,6.10002943 C8.5209139,6.26571485 8.56568542,6.57911553 8.4,6.80002943 C7.31481624,8.2469411 6.18518376,9.00002943 5,9.00002943 C3.81481624,9.00002943 2.68518376,8.2469411 1.6,6.80002943 C1.43431458,6.57911553 1.4790861,6.26571485 1.7,6.10002943 C1.9209139,5.934344 2.23431458,5.97911553 2.4,6.20002943 C3.31481624,7.41978441 4.18518376,8.00002943 5,8.00002943 C5.81481624,8.00002943 6.68518376,7.41978441 7.6,6.20002943 Z'
  }]
}, {
  id: 'vertical-wave',
  children: [{
    tagName: 'path',
    d: 'M5,4.372 C3.531,4.372 2.785,3.662 2.127,3.035 C1.515,2.452 1.031,1.992 0,1.992 L0,1 C1.469,1 2.215,1.71 2.874,2.337 C3.486,2.92 3.969,3.38 5,3.38 C6.031,3.38 6.515,2.92 7.127,2.337 C7.785,1.71 8.531,1 10,1 L10,1.992 C8.969,1.992 8.485,2.452 7.873,3.035 C7.215,3.662 6.469,4.372 5,4.372 Z M5,9.372 C3.531,9.372 2.785,8.662 2.127,8.035 C1.515,7.452 1.031,6.992 0,6.992 L0,6 C1.469,6 2.215,6.71 2.874,7.337 C3.486,7.92 3.969,8.38 5,8.38 C6.031,8.38 6.515,7.92 7.127,7.337 C7.785,6.71 8.531,6 10,6 L10,6.992 C8.969,6.992 8.485,7.452 7.873,8.035 C7.215,8.662 6.469,9.372 5,9.372 Z',
    transform: 'translate(5.000000, 5.000000) rotate(90.000000) translate(-5.000000, -5.000000)'
  }]
}, {
  id: 'metal',
  children: [{
    tagName: 'path',
    d: 'M3.14644661,7.3890873 L7.3890873,3.14644661 C7.58434944,2.95118446 7.90093193,2.95118446 8.09619408,3.14644661 C8.29145622,3.34170876 8.29145622,3.65829124 8.09619408,3.85355339 L3.85355339,8.09619408 C3.65829124,8.29145622 3.34170876,8.29145622 3.14644661,8.09619408 C2.95118446,7.90093193 2.95118446,7.58434944 3.14644661,7.3890873 Z'
  }, {
    tagName: 'path',
    d: 'M1.14644661,5.3890873 L5.3890873,1.14644661 C5.58434944,0.951184464 5.90093193,0.951184464 6.09619408,1.14644661 C6.29145622,1.34170876 6.29145622,1.65829124 6.09619408,1.85355339 L1.85355339,6.09619408 C1.65829124,6.29145622 1.34170876,6.29145622 1.14644661,6.09619408 C0.951184464,5.90093193 0.951184464,5.58434944 1.14644661,5.3890873 Z'
  }]
}, {
  id: 'scales',
  children: [{
    tagName: 'path',
    d: 'M-4.59407723,4.76499947 C-4.74043239,4.99916774 -5.04890759,5.07035432 -5.28307585,4.92399915 C-5.51724412,4.77764399 -5.5884307,4.4691688 -5.44207553,4.23500053 C-3.6935114,1.43729791 -1.89688901,1.25154062e-16 -0.0180763806,0 C1.86073624,0 3.65735864,1.43729791 5.40592277,4.23500053 C5.55227794,4.4691688 5.48109135,4.77764399 5.24692309,4.92399915 C5.01275482,5.07035432 4.70427963,4.99916774 4.55792447,4.76499947 C2.97315527,2.22936875 1.43644433,1 -0.0180763806,1 C-1.47259709,1 -3.00930803,2.22936875 -4.59407723,4.76499947 Z'
  }, {
    tagName: 'path',
    d: 'M5.42399915,4.76499947 C5.27764399,4.99916774 4.9691688,5.07035432 4.73500053,4.92399915 C4.50083226,4.77764399 4.42964568,4.4691688 4.57600085,4.23500053 C6.32456498,1.43729791 8.12118738,1.25154062e-16 10,0 C11.8788126,0 13.675435,1.43729791 15.4239992,4.23500053 C15.5703543,4.4691688 15.4991677,4.77764399 15.2649995,4.92399915 C15.0308312,5.07035432 14.722356,4.99916774 14.5760008,4.76499947 C12.9912316,2.22936875 11.4545207,1 10,1 C8.54547929,1 7.00876835,2.22936875 5.42399915,4.76499947 Z'
  }, {
    tagName: 'path',
    d: 'M0.423999152,9.76499947 C0.277643986,9.99916774 -0.0308312044,10.0703543 -0.26499947,9.92399915 C-0.499167736,9.77764399 -0.570354318,9.4691688 -0.423999152,9.23500053 C1.32456498,6.43729791 3.12118738,5 5,5 C6.87881262,5 8.67543502,6.43729791 10.4239992,9.23500053 C10.5703543,9.4691688 10.4991677,9.77764399 10.2649995,9.92399915 C10.0308312,10.0703543 9.72235601,9.99916774 9.57600085,9.76499947 C7.99123165,7.22936875 6.45452071,6 5,6 C3.54547929,6 2.00876835,7.22936875 0.423999152,9.76499947 Z'
  }]
}, {
  id: 'triangle',
  children: [{
    tagName: 'path',
    d: 'M2,0 L4,4 L0,4 L2,0 Z M7,9 L5,5 L9,5 L7,9 Z'
  }]
}, {
  id: 'horizontal-wave',
  children: [{
    tagName: 'path',
    d: 'M5,3.372 C3.531,3.372 2.785,2.662 2.127,2.035 C1.515,1.452 1.031,0.992 0,0.992 L0,0 C1.469,0 2.215,0.71 2.874,1.337 C3.486,1.92 3.969,2.38 5,2.38 C6.031,2.38 6.515,1.92 7.127,1.337 C7.785,0.71 8.531,0 10,0 L10,0.992 C8.969,0.992 8.485,1.452 7.873,2.035 C7.215,2.662 6.469,3.372 5,3.372 Z M5,8.372 C3.531,8.372 2.785,7.662 2.127,7.035 C1.515,6.452 1.031,5.992 0,5.992 L0,5 C1.469,5 2.215,5.71 2.874,6.337 C3.486,6.92 3.969,7.38 5,7.38 C6.031,7.38 6.515,6.92 7.127,6.337 C7.785,5.71 8.531,5 10,5 L10,5.992 C8.969,5.992 8.485,6.452 7.873,7.035 C7.215,7.662 6.469,8.372 5,8.372 Z'
  }]
}, {
  id: 'cage',
  children: [{
    tagName: 'path',
    d: 'M3.66326332,1.71913643 C3.07747688,1.13334999 2.12772941,1.13334999 1.54194298,1.71913643 C0.956156539,2.30492287 0.956156539,3.25467034 1.54194298,3.84045677 L4.3703701,6.6688839 C4.95615654,7.25467034 5.90590401,7.25467034 6.49169045,6.6688839 C7.07747688,6.08309746 7.07747688,5.13334999 6.49169045,4.54756355 L3.66326332,1.71913643 Z M4.3703701,1.01202965 L7.19879723,3.84045677 C8.17510796,4.8167675 8.17510796,6.39967995 7.19879723,7.37599068 C6.2224865,8.35230141 4.63957405,8.35230141 3.66326332,7.37599068 L0.834836196,4.54756355 C-0.141474534,3.57125282 -0.141474534,1.98834038 0.834836196,1.01202965 C1.81114693,0.0357189189 3.39405937,0.0357189189 4.3703701,1.01202965 Z'
  }]
}, {
  id: 'line-dot',
  children: [{
    tagName: 'path',
    d: 'M0.375,0 L1.375,0 L1.375,5 L0.375,5 L0.375,0 Z M0.875,8.375 C0.3915625,8.375 0,7.9834375 0,7.5 C0,7.0165625 0.3915625,6.625 0.875,6.625 C1.3584375,6.625 1.75,7.0165625 1.75,7.5 C1.75,7.9834375 1.3584375,8.375 0.875,8.375 Z M5.375,5 L6.375,5 L6.375,10 L5.375,10 L5.375,5 Z M5.895,3.375 C5.4115625,3.375 5.02,2.9834375 5.02,2.5 C5.02,2.0165625 5.4115625,1.625 5.895,1.625 C6.3784375,1.625 6.77,2.0165625 6.77,2.5 C6.77,2.9834375 6.3784375,3.375 5.895,3.375 Z'
  }]
}, {
  id: 'squares',
  children: [{
    tagName: 'path',
    d: 'M6,6 L6,9 L9,9 L9,6 L6,6 Z M6,5 L9,5 C9.55228475,5 10,5.44771525 10,6 L10,9 C10,9.55228475 9.55228475,10 9,10 L6,10 C5.44771525,10 5,9.55228475 5,9 L5,6 C5,5.44771525 5.44771525,5 6,5 Z'
  }, {
    tagName: 'path',
    d: 'M1,1 L1,4 L4,4 L4,1 L1,1 Z M1,0 L4,0 C4.55228475,-1.01453063e-16 5,0.44771525 5,1 L5,4 C5,4.55228475 4.55228475,5 4,5 L1,5 C0.44771525,5 0,4.55228475 0,4 L0,1 C0,0.44771525 0.44771525,1.01453063e-16 1,0 Z'
  }]
}];
var dashStyles = ['0', addGap([dot], shortGap), addGap([shortDash], shortGap), addGap([shortDash, dot], shortGap), addGap([shortDash, dot, dot], shortGap), addGap([shortDash, dot, dot, dot], shortGap), addGap([dot], longGap), addGap([shortDash], longGap), addGap([shortDash, dot], longGap), addGap([shortDash, dot, dot], longGap), addGap([shortDash, dot, dot, dot], longGap), addGap([longDash], shortGap), addGap([longDash, dot], shortGap), addGap([longDash, dot, dot], shortGap), addGap([longDash, dot, dot, dot], shortGap), addGap([longDash], longGap), addGap([longDash, dot], longGap), addGap([longDash, dot, dot], longGap), addGap([longDash, dot, dot, dot], longGap), addGap([longDash, shortDash], shortGap), addGap([longDash, shortDash, shortDash], shortGap), addGap([longDash, shortDash, shortDash, shortDash], shortGap), addGap([longDash, shortDash], longGap), addGap([longDash, shortDash, shortDash], longGap), addGap([longDash, shortDash, shortDash, shortDash], longGap)];
var dashStyleOrder = [0, 1, 7, 3, 15, 13, 9, 2, 6, 19, 8, 14, 23, 4, 10, 11, 22, 5, 24, 12];
export var fillPatterns = fillPatternProps.map(function (pattern) {
  return _assign({}, pattern, {
    patternProps: {
      width: FILL_PATTERN_WIDTH,
      height: FILL_PATTERN_HEIGHT,
      patternUnits: 'userSpaceOnUse'
    }
  });
});
export var linePatterns = dashStyleOrder.map(function (index) {
  return dashStyles[index];
});